import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Box,
  Typography,
  Stack,
  Button,
  IconButton,
  MenuItem,
  Select,
  FormControl,
  InputLabel,
  Tooltip,
  Modal,
} from "@mui/material";

import VisibilityIcon from "@mui/icons-material/Visibility";
import ManageSearchIcon from "@mui/icons-material/ManageSearch";

// ICONO ROBOT
import SmartToyIcon from "@mui/icons-material/SmartToy";

import { DataGrid, GridColDef } from "@mui/x-data-grid";

import {
  getExpedientes2,
  Expediente2,
} from "../services/expedientes2.service";

import DoxeoModal from "./DoxeoModal";
import LegalBot from "../legalbot/LegalBot";

// TU COMPONENTE IA


/* ===================== HELPERS ===================== */

const formatDate = (value?: string) => {
  if (!value) return "";
  if (value.includes("T")) {
    return new Date(value).toLocaleDateString("es-PE");
  }
  const [year, month, day] = value.split("-");
  return `${day}/${month}/${year}`;
};

const BASE_URL =
  "https://prodapp5.oece.gob.pe/portaltribunal-uiwd-pub/ControllerServletOpen" +
  "?scriptdo=usp_expedientes_buscar_doview_tm_pub" +
  "&portletid=usp_expedientes_buscar_doview_tm_pub" +
  "&idexpediente=";

/* ===================== COMPONENT ===================== */

const Dashboard2Page = () => {
  const navigate = useNavigate();

  const [rows, setRows] = useState<Expediente2[]>([]);
  const [loading, setLoading] = useState(false);
  const [anioFiltro, setAnioFiltro] = useState("2026");

  // Modal doxeo
  const [openDoxeo, setOpenDoxeo] = useState(false);

  // MODAL IA
  const [openIA, setOpenIA] = useState(false);

  /* ===================== AUTH ===================== */

  const handleLogout = () => {
    localStorage.removeItem("token");
    navigate("/login");
  };

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (!token) navigate("/login");
  }, [navigate]);

  /* ===================== DATA ===================== */

  const fetchData = async (anio?: string) => {
    setLoading(true);
    try {
      const resp = anio
        ? await getExpedientes2(anio)
        : await getExpedientes2();

      setRows(resp?.data || []);
    } catch (err) {
      console.error(err);
      setRows([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData(anioFiltro);
  }, [anioFiltro]);

  /* ===================== COLUMNS ===================== */

  const columns: GridColDef[] = [
    {
      field: "expediente",
      headerName: "Expediente",
      flex: 1.5,
      renderCell: (params) => (
        <Box
          sx={{ cursor: "pointer" }}
          onClick={() =>
            navigator.clipboard.writeText(params.value as string)
          }
        >
          {params.value}
        </Box>
      ),
    },
    { field: "nro_proceso", headerName: "N° Proceso", flex: 1.2 },
    { field: "ruc", headerName: "RUC", flex: 1.2 },
    {
      field: "fecha_expediente",
      headerName: "Fecha",
      flex: 1.2,
      valueGetter: (value) => formatDate(value as string),
    },
    {
      field: "acciones",
      headerName: "",
      width: 80,
      sortable: false,
      renderCell: (params) => (
        <VisibilityIcon
          sx={{ cursor: "pointer" }}
          onClick={() =>
            window.open(
              `${BASE_URL}${encodeURIComponent(params.row.expediente)}`,
              "_blank"
            )
          }
        />
      ),
    },
  ];

  /* ===================== RENDER ===================== */

  return (
    <Box p={3}>
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        mb={2}
      >
        <Typography variant="h6" fontWeight={600}>
          Expedientes
        </Typography>

        <Stack direction="row" spacing={2} alignItems="center">
          <FormControl size="small">
            <InputLabel>Año</InputLabel>

            <Select
              value={anioFiltro}
              label="Año"
              onChange={(e) => setAnioFiltro(e.target.value)}
            >
              <MenuItem value="">Todos</MenuItem>
              <MenuItem value="2024">2024</MenuItem>
              <MenuItem value="2025">2025</MenuItem>
              <MenuItem value="2026">2026</MenuItem>
            </Select>
          </FormControl>

          {/* BOTON DOXEO */}
          <Tooltip title="Búsqueda RENIEC">
            <IconButton onClick={() => setOpenDoxeo(true)}>
              <ManageSearchIcon />
            </IconButton>
          </Tooltip>

          {/* BOTON IA */}
          <Tooltip title="Asistente IA">
            <IconButton
              onClick={() => setOpenIA(true)}
              sx={{
                backgroundColor: "#1976d2",
                color: "white",
                "&:hover": {
                  backgroundColor: "#1565c0",
                },
              }}
            >
              <SmartToyIcon />
            </IconButton>
          </Tooltip>



          <Button color="error" variant="contained" onClick={handleLogout}>
            Logout
          </Button>
        </Stack>
      </Stack>

      <DataGrid
        rows={rows}
        columns={columns}
        loading={loading}
        autoHeight
        pageSizeOptions={[5, 10, 20]}
        disableRowSelectionOnClick
      />

      {/* MODAL DOXEO */}
      <DoxeoModal open={openDoxeo} onClose={() => setOpenDoxeo(false)} />
<Modal open={openIA} onClose={() => setOpenIA(false)}>
  <Box
    sx={{
      position: "absolute",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      width: "95%",
      height: "95%",
      bgcolor: "white",
      borderRadius: 3,
      overflow: "hidden",
      boxShadow: 24,
    }}
  >
    <IconButton
      onClick={() => setOpenIA(false)}
      sx={{
        position: "absolute",
        top: 10,
        right: 10,
        zIndex: 1000,
      }}
    >
      ✕
    </IconButton>

    <LegalBot />
  </Box>
</Modal>
      {/* MODAL IA */}
    </Box>
  );
};

export default Dashboard2Page;